import { solutionsLimitStep } from '../constants/solutions-limit-step';
var SearchStateService = (function () {
    function SearchStateService() {
        this.solutionsLimitStep = solutionsLimitStep;
        this.solutionsLimit = solutionsLimitStep;
        this.solutionsMaxLimit = solutionsLimitStep;
    }
    SearchStateService.prototype.resetSolutionsLimit = function () {
        this.solutionsLimit = solutionsLimitStep;
        this.solutionsMaxLimit = solutionsLimitStep;
    };
    SearchStateService.prototype.setSolutionsLimit = function (limit) {
        this.solutionsLimit = limit;
    };
    SearchStateService.prototype.maximizeSolutionsLimit = function () {
        this.solutionsLimit = this.solutionsMaxLimit;
    };
    SearchStateService.$inject = [];
    return SearchStateService;
}());
export { SearchStateService };
